import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M15 9a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M9 9a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M6 15a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-3"}],["path",{"d":"M12 15a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-4"}]]

const IconOlympics = createReactComponent('outline', 'olympics', 'Olympics', __iconNode);

export default IconOlympics;